import React from 'react';
import ReactDOM from 'react-dom/client';
import { StoreProvider } from 'easy-peasy';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import store from "./store/index";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <I18nextProvider i18n={i18n}>
            <App />
      </I18nextProvider>
    </StoreProvider>
  </React.StrictMode>
);

